import type { RouteParamsRequest } from '@pba/react-utils';
import { type ApiClientResponse, apiClient, routes } from 'common/services';

export const likeObject = async ({ routeParams: { id } }: RouteParamsRequest<{ id: string }>) =>
  apiClient.post<unknown, ApiClientResponse<unknown>>(routes.contentObjects.like.create(id));
